export default __webpack_public_path__ + "static/media/legal-team-defendant.fc9a8527.jpg";